import { getUno } from '../api/apis';

/**
 * función para obtener datos para un datatable de forma genérica.
 * @param {Object} options
 * @param {string} options.url - Endpoint para la consulta.
 * @param {string} options.initialSortBy - Columna de orden inicial.
 * @param {string} options.initialSortDir - Dirección de orden inicial.
 * @param {string[]} options.dataPath - Array con las claves para acceder al array de datos en la respuesta.
 * @param {string[]} options.totalPath - Array con las claves para acceder al total en la respuesta.
 * @returns {Function} Callback para usar en Datatable.requestDataFn
 */
export function createFetchTableData({ url, initialSortBy, initialSortDir, dataPath = ['data', 'data', 'data'], totalPath = ['data', 'data', 'total'] }) {
  return async function fetchTableData(params) {
    const filtrosArr = [];
    if (params.search) {
      filtrosArr.push({ tipo: 'general', valor: params.search });
    }
    Object.entries(params.filters).forEach(([columna, valor]) => {
      if (valor && valor.trim()) {
        filtrosArr.push({ tipo: 'columna', columna, valor: valor.trim() });
      }
    });

    const sortBy = params.sortBy || initialSortBy;
    const sortDir = params.sortDir || initialSortDir;

    const queryParams = {
      page: params.page,
      total_page: params.perPage,
      filtros: JSON.stringify(filtrosArr),
      sort_by: sortBy,
      sort_dir: sortDir
    };

    try {
      const resp = await getUno(url, queryParams, null);
      // Acceso dinámico a los datos y total
      let data = resp;
      for (const key of dataPath) {
        data = data[key];
      }
      let total = resp;
      for (const key of totalPath) {
        total = total[key];
      }
      return { data, total };
    } catch (error) {
      console.error('Error al cargar datos:', error);
      return { data: [], total: 0 };
    }
  };
  }
